import { Button, Grid, Badge } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { TaskService } from 'lib/api'
import { WorkListTaksCardDesktop } from './WorkListTaksCard.desktop'
import { AsterToggleButton, AsterToggleButtonGroup } from 'asterX-UI/Buttons'
import { useWorkListViewRopStore } from 'context/WorkListViewStore/Rop/WorkListViewStore.rop'
import { NotFound } from 'components/NotFound'
import { WorkListTaskCardMobile } from './WorkListTaskCard.mobile'
import { WorkListTaskModal } from './WorkListTaskModal'
import AddIcon from '@material-ui/icons/Add'
import { Modal } from '../../../asterX-UI/Modals'
import CreateTaskComponent from '../../Desktop/Tasks/CreateTaskComponent'
import { PAYMENT, SUCCESS } from 'constants/deals'
import {
  CS_CALL_CLIENT,
  CS_ISSUANCE_CAR,
  CS_ISSUE_MANAGER,
  CS_MEET_CLIENT,
  MISSING
} from 'constants/events'

export const WorkListTasks = ({ id }) => {
  const {
    store: { wlData },
    actions: { setLoading }
  } = useWorkListViewRopStore()

  const isMobile = window.innerWidth < 768

  const [tasks, setTasks] = useState(null)
  const [currentTask, setCurrentTask] = useState(null)
  const [taskOpen, setTaskOpen] = useState(false)
  const [createTask, setCreateTask] = useState(false)
  const [taskCount, setTaskCounts] = useState({})
  const [taskFilter, setTaskFilter] = useState({
    taskStatus: 'open'
  })

  const getEvents = async () => {
    setLoading(true)

    const data = {
      dealId: id,
      completed: taskFilter.taskStatus !== 'open',
      types: [
        CS_CALL_CLIENT,
        CS_MEET_CLIENT,
        CS_ISSUANCE_CAR,
        CS_ISSUE_MANAGER,
        MISSING
      ]
    }

    TaskService.getEvents(data)
      .then(res => {
        if (res?.data) {
          setTasks(res.data.listEvents)
          setTaskCounts({ [taskFilter.taskStatus]: res.data.countFiltered })
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleOpenTask = task => {
    setCurrentTask(task)
    setTaskOpen(true)
  }

  useEffect(() => {
    if (id) {
      getEvents()
    }
  }, [id, taskFilter.taskStatus])

  return (
    <Grid container alignItems={'center'} justifyContent={'space-between'}>
      <Grid item>
        <AsterToggleButtonGroup
          exclusive
          value={taskFilter.taskStatus}
          onChange={(e, val) =>
            setTaskFilter(prevState => ({ ...prevState, taskStatus: val }))
          }
        >
          <AsterToggleButton value="open">
            <Badge badgeContent={taskCount?.open} color="primary" max={9999}>
              Открытые
            </Badge>
          </AsterToggleButton>
          <AsterToggleButton value="closed">
            <Badge badgeContent={taskCount?.closed} color="primary" max={9999}>
              Закрытые
            </Badge>
          </AsterToggleButton>
        </AsterToggleButtonGroup>
      </Grid>
      {wlData?.saleStatus?.code !== SUCCESS && (
        <Grid item>
          <Button
            color={'primary'}
            variant={'contained'}
            size={'small'}
            onClick={() => setCreateTask(true)}
          >
            <AddIcon />
            Добавить задачу
          </Button>
        </Grid>
      )}
      <Grid item container spacing={3} style={{ marginTop: 20 }}>
        {tasks?.length ? (
          tasks.map((e, i) => (
            <Grid key={`work-list-view-${i}`} item xs={12}>
              {isMobile ? (
                <WorkListTaskCardMobile task={e} onClick={handleOpenTask} />
              ) : (
                <WorkListTaksCardDesktop task={e} onClick={handleOpenTask} />
              )}
            </Grid>
          ))
        ) : (
          <NotFound title="Нет задач" />
        )}
      </Grid>
      {taskOpen && (
        <WorkListTaskModal
          task={currentTask}
          isOpen={taskOpen}
          onClose={() => {
            setTaskOpen(false)
            getEvents()
          }}
        />
      )}
      {createTask && (
        <Modal open={createTask} fullWidth>
          <CreateTaskComponent
            saleId={wlData?.id}
            globalId={wlData?.globalId}
            isPayment={wlData?.saleStatus?.code === PAYMENT}
            client={{
              contactFullname:
                wlData.client?.firstName + ' ' + wlData.client?.lastName || '',
              phoneNumber: wlData?.client?.phoneNumber || '',
              additionalPhoneNumber: wlData?.client?.additionalPhoneNumber || ''
            }}
            onClose={() => setCreateTask(false)}
            onSuccess={() => {
              setCreateTask(false)
              getEvents()
            }}
            otherData={{
              assignToFullName: wlData?.assignToFullName,
              assignTo: wlData?.assignTo
            }}
          />
        </Modal>
      )}
    </Grid>
  )
}
